var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", { attrs: { href: "#tab-1" } }, [_vm._v("Auditoría")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.eventos,
                  label: "Evento",
                  "item-value": "id",
                  "item-text": "nombre",
                  "error-messages": _vm.errors.collect("evento"),
                  "data-vv-name": "evento",
                  "no-data-text": "Sin resultados",
                  autocomplete: ""
                },
                model: {
                  value: _vm.filtroGrillaEvento,
                  callback: function($$v) {
                    _vm.filtroGrillaEvento = $$v
                  },
                  expression: "filtroGrillaEvento"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  model: {
                    value: _vm.menuDatePickerFechaD,
                    callback: function($$v) {
                      _vm.menuDatePickerFechaD = $$v
                    },
                    expression: "menuDatePickerFechaD"
                  }
                },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''"
                      }
                    ],
                    attrs: {
                      slot: "activator",
                      label: "Fecha Desde",
                      "persistent-hint": "",
                      "prepend-icon": "event",
                      "error-messages": _vm.errors.collect("fechaDesde"),
                      "data-vv-name": "fechaDesde",
                      readonly: ""
                    },
                    slot: "activator",
                    model: {
                      value: _vm.computedDateFormattedFechaD,
                      callback: function($$v) {
                        _vm.computedDateFormattedFechaD = $$v
                      },
                      expression: "computedDateFormattedFechaD"
                    }
                  }),
                  _c("v-date-picker", {
                    key: _vm.keyDatePickers,
                    attrs: {
                      "first-day-of-week": "1",
                      locale: "es-cl",
                      scrollable: "",
                      max: _vm.maxDate
                    },
                    on: {
                      input: function($event) {
                        _vm.menuDatePickerFechaD = false
                      }
                    },
                    model: {
                      value: _vm.filtroGrillaFechaD,
                      callback: function($$v) {
                        _vm.filtroGrillaFechaD = $$v
                      },
                      expression: "filtroGrillaFechaD"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  model: {
                    value: _vm.menuDatePickerFechaH,
                    callback: function($$v) {
                      _vm.menuDatePickerFechaH = $$v
                    },
                    expression: "menuDatePickerFechaH"
                  }
                },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''"
                      }
                    ],
                    attrs: {
                      slot: "activator",
                      label: "Fecha Hasta",
                      "persistent-hint": "",
                      "prepend-icon": "event",
                      "error-messages": _vm.errors.collect("fechaHasta"),
                      "data-vv-name": "fechaHasta",
                      readonly: ""
                    },
                    slot: "activator",
                    model: {
                      value: _vm.computedDateFormattedFechaH,
                      callback: function($$v) {
                        _vm.computedDateFormattedFechaH = $$v
                      },
                      expression: "computedDateFormattedFechaH"
                    }
                  }),
                  _c("v-date-picker", {
                    key: _vm.keyDatePickers,
                    attrs: {
                      "first-day-of-week": "1",
                      locale: "es-cl",
                      scrollable: "",
                      min: _vm.minDate
                    },
                    on: {
                      input: function($event) {
                        _vm.menuDatePickerFechaH = false
                      }
                    },
                    model: {
                      value: _vm.filtroGrillaFechaH,
                      callback: function($$v) {
                        _vm.filtroGrillaFechaH = $$v
                      },
                      expression: "filtroGrillaFechaH"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.usuarios,
                  label: "Usuario",
                  "item-value": "id",
                  "item-text": "nombreCompleto",
                  "error-messages": _vm.errors.collect("usuario"),
                  "data-vv-name": "usuario",
                  "no-data-text": "Sin resultados",
                  autocomplete: ""
                },
                model: {
                  value: _vm.filtroGrillaUsuario,
                  callback: function($$v) {
                    _vm.filtroGrillaUsuario = $$v
                  },
                  expression: "filtroGrillaUsuario"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md2: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } }, [
            _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.onFilterTextBoxChanged }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      flat: "",
                      icon: "",
                      small: "",
                      disabled: _vm.btnDisabled
                    },
                    on: { click: _vm.clearFilters }
                  },
                  [_c("v-icon", [_vm._v("clear")])],
                  1
                )
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } }, [
            _c(
              "div",
              {
                staticStyle: { "padding-top": "15px" },
                attrs: { align: "right" }
              },
              [
                _vm.accionExportar.visible
                  ? _c(
                      "v-btn",
                      {
                        attrs: { flat: "", small: "", color: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.exportar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v("  \n          "),
                        _c("span", { staticClass: "importExportBtnTexto" }, [
                          _vm._v("Exportar")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "gridcard rounded-card",
          staticStyle: { "margin-top": "10px" }
        },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "auto",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showCantidadRegistros,
                callback: function($$v) {
                  _vm.showCantidadRegistros = $$v
                },
                expression: "showCantidadRegistros"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Consultar Auditoría")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "div",
                    { attrs: { id: "alinear" } },
                    [
                      _c("v-card-text", [
                        _vm._v(
                          "No es posible obtener la información solicitada. Ha sobrepasado\n            el límite de registros, considere limitar el periodo de\n            consulta."
                        )
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackCantidadRegistros(true)
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }